export interface Testimonio {
  id: string
  texto: string
  nombre: string
  ciudad: string
  foto: string
}

export const testimonios: Testimonio[] = [
  {
    id: 't1',
    texto:
      'Llevaba meses sin saber nada de él y con el corazón hecho pedazos. Me explicaron cada paso del trabajo con paciencia y fe. Hoy estamos juntos otra vez y con la relación más tranquila que nunca.',
    nombre: 'Marisol Aguilar',
    ciudad: 'Houston, TX',
    foto: 'https://cdn.magicpatterns.com/patterns/generated-images/b4fb6a31-ba30-46b9-b5b7-03d5d3baefc0.jpg',
  },
  {
    id: 't2',
    texto:
      'Todo en mi negocio estaba cerrado, no entraba un solo cliente. Hicimos una limpieza energética y una apertura de caminos. En tres semanas comencé a ver el movimiento que tanto esperaba.',
    nombre: 'Javier Montoya',
    ciudad: 'Los Ángeles, CA',
    foto: 'https://cdn.magicpatterns.com/patterns/generated-images/91e953ac-f372-4348-acae-9a3b34433622.jpg',
  },
  {
    id: 't3',
    texto:
      'Necesitaba cerrar un ciclo que me estaba haciendo mucho daño. Me acompañaron con respeto y sin promesas falsas. Por fin siento paz en mi casa y puedo dormir tranquila.',
    nombre: 'Carmen Robles',
    ciudad: 'Chicago, IL',
    foto: 'https://cdn.magicpatterns.com/patterns/generated-images/e507505c-bc0d-40b7-9762-cd1b3d955e81.jpg',
  },
]
